import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import {
  Label,
  FormGroup,
  Form,
  Button,
  ButtonGroup,
  Input,
  Col,
  Row,
  Collapse,
  UncontrolledTooltip,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import Header from '../components/Header';
import FileTable from '../components/tables/FileTable';
import AuthHOC from './Auth';
import { Flag } from 'flagger/react';
import SearchIcon from '@mui/icons-material/Search';
import ExportDataRowsModal from '../components/modals/ExportDataRowsModal';
import { Stack, Typography, Box, Button as MuiButton } from '@mui/material';

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      additional_count: 1,
      search_text: '',
      files: [],
      DocuemntTypes: [],
      DocumentType: '',
      DocumentRef: '',
      Folder: '',
      Folders: [],
      UserName: '',
      locale: 'en',
      collapse: true,
      token: {},
      addbuttonenabled: true,
      count: 0,
      loading: false,
      exportFilesModalVisible: false,
      toastVisible: false,
      toastText: '',
      toastColor: 'info',
    };

    this.additional = this.additional.bind(this);
    this.remove = this.remove.bind(this);
    this.submit = this.submit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateInputChange = this.handleDateInputChange.bind(this);
    this.collapse = this.collapse.bind(this);
    this.refresh = this.refresh.bind(this);
    this.clearstatebtn = this.clearstatebtn.bind(this);
  }

  componentDidMount() {
    this.getFolders();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.Folder !== prevState.Folder) {
      this.getDocTypes();
    }
  }

  getFolders = () => {
    fetch(
      window.location.protocol +
        '//' +
        window.location.host +
        '/api/configuration/folder'
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          Folders: Array.isArray(result) ? result : [],
        });
      })
      .catch(() => {});
  };

  getDocTypes = () => {
    fetch(
      window.location.protocol +
        '//' +
        window.location.host +
        '/api/configuration/documentTypes?folder=' +
        this.state.Folder
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          DocuemntTypes: Array.isArray(result) ? result : [],
        });
      })
      .catch(() => {});
  };

  collapse() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  additional() {
    this.setState({
      additional_count: this.state.additional_count + 1,
      count: this.state.count + 1,
      addbuttonenabled: false,
    });
    //disable click
  }

  remove(e) {
    var id = e.target.id;
    let documentData = 'documentData' + id;
    let operator = 'operator' + id;
    let value = 'value' + id;

    $('#filter' + id).remove();

    var count = this.state.count - 1;
    var enableadd = count === 0;

    this.setState({
      count: count,
      [documentData]: '',
      [operator]: '',
      [value]: '',
      addbuttonenabled: true,
    });
  }

  refresh() {
    this.submit();
  }

  // preform an elastic search from main search box

  //added a comment!!!!!!!
  genericSearch = () => {
    this.isLoading(true);
    fetch(
      window.location.protocol +
        '//' +
        window.location.host +
        '/api/archive/elastic_search',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query: this.state.search_text }),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          files: result,
        });
        this.isLoading(false);
      });
  };

  isLoading = (loading) => {
    this.setState({
      loading,
    });
  };

  exportButtonPressed = () => {
    this.setState({
      exportFilesModalVisible: !this.state.exportFilesModalVisible,
    });
  };

  submit(event) {
    this.isLoading(true);

    let query = {};
    query.DocumentData = [];

    if (this.state.DocumentRef) query['DocumentRef'] = this.state.DocumentRef;
    if (this.state.DocumentType)
      query['DocumentType'] = this.state.DocumentType;
    if (this.state.DateRageFrom)
      query['DateRangeFrom'] = this.state.DateRageFrom;
    if (this.state.DateRageTo) query['DateRangeTo'] = this.state.DateRageTo;
    if (this.state.UserName) query['UserName'] = this.state.UserName;
    if (this.state.Folder) query['Folder'] = this.state.Folder;
    if (this.state.TransactionNumber)
      query['TransactionNumber'] = this.state.TransactionNumber;
    if (this.state.TransactionDate)
      query['TransactionDate'] = this.state.TransactionDate;
    if (this.state.TransactionValue)
      query['TransactionValue'] = this.state.TransactionValue;
    if (this.state.Customer) query['Customer'] = this.state.Customer;
    if (this.state.BPNUMBER) query['BPNUMBER'] = this.state.BPNUMBER;
    if (this.state.OrderRef) query['OrderRef'] = this.state.OrderRef;
    if (this.state.Description) query['Description'] = this.state.Description;

    for (let i = 0; i < this.state.additional_count; i++) {
      let documentData = 'documentData' + i;
      let operator = 'operator' + i;
      let value = 'value' + i;

      if (this.state[documentData] && this.state[value]) {
        query.DocumentData.push({
          [this.state[documentData]]: {
            operator: this.state[operator],
            value: this.state[value],
          },
        });
      }
    }

    this.setState({ files: [] }, () => {
      fetch(
        window.location.protocol +
          '//' +
          window.location.host +
          '/api/archive/search',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(query),
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          this.setState({
            files: result,
            collapse: false,
          });
          this.isLoading(false);
        });
    });

    if (event) event.preventDefault();
  }

  handleDownloadSelected = async (ids) => {
    if (!ids?.length) return;
    if (ids.length > 250) {
      this.showToast('Download limit reached for a single request.', 'danger', 6000);
      return;
    }
    this.showToast(`Preparing download for ${ids.length} document${ids.length > 1 ? 's' : ''}…`, 'info', 6000);
    this.isLoading(true);
    try {
      const res = await fetch(
        `${window.location.protocol}//${window.location.host}/api/archive/download-batch`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ ids }),
        }
      );
      if (!res.ok) {
        const text = await res.text();
        this.showToast(text || 'Download failed.', 'danger', 7000);
        return;
      }
      // zip is ready
      this.showToast('Download starting…', 'success', 3000);

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');

      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_` + `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;

      a.href = url;
      a.download = `documents_${stamp}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

    }
    finally {
      this.isLoading(false);
    }
  }

  updateDocRef = (ref) => {
    this.setState({ DocumentRef: ref.target.value });
  };
  updateDocType = (type) => {
    this.setState({ DocumentType: type.target.value });
  };
  updateUserName = (name) => {
    this.setState({ UserName: name.target.value });
  };
  updateFolder = (ref) => {
    this.setState({ Folder: ref.target.value });
  };
  updateTransactionValue = (ref) => {
    this.setState({ TransactionValue: ref.target.value });
  };
  updateTransactionNumber = (ref) => {
    this.setState({ TransactionNumber: ref.target.value });
  };
  updateTransactionDate = (ref) => {
    this.setState({ TransactionDate: ref.target.value });
  };
  updateCustomerNumber = (ref) => {
    this.setState({ Customer: ref.target.value });
  };
  updateBPNumber = (ref) => {
    this.setState({ BPNUMBER: ref.target.value });
  };

  updateOrderRef = (ref) => {
    this.setState({ OrderRef: ref.target.value });
  };

  updateDescription = (ref) => {
    this.setState({ Description: ref.target.value });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    var id = '0';
    var buttonEnabled = false;
    //get the id from the entered target
    if (name.includes('documentData')) {
      id = name.substring(12);
      if (
        value !== '' &&
        value !== 'Select ...' &&
        this.state['value' + id] !== '' &&
        typeof this.state['value' + id] != 'undefined'
      ) {
        buttonEnabled = true;
      }
    } else if (name.includes('value')) {
      id = name.substring(5);
      if (
        value !== '' &&
        this.state['documentData' + id] !== '' &&
        typeof this.state['documentData' + id] != 'undefined'
      ) {
        buttonEnabled = true;
      }
    } else {
      id = name.substring(8);
      if (
        this.state['value' + id] !== '' &&
        typeof this.state['value' + id] != 'undefined' &&
        this.state['documentData' + id] !== '' &&
        typeof this.state['documentData' + id] != 'undefined'
      ) {
        buttonEnabled = true;
      }
    }

    this.setState({
      [name]: value,
      addbuttonenabled: buttonEnabled,
    });
  }

  handleDateInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  clearstatebtn() {
    this.setState({
      search_text: '',
      DocumentType: '',
      DocumentRef: '',
      Folder: '',
      UserName: '',
      TransactionNumber: '',
      TransactionDate: '',
      TransactionValue: '',
      Customer: '',
      BPNUMBER: '',
      OrderRef: '',
      Description: '',
      DateRageFrom: '',
      DateRageTo: '',
      additional_count: 1,
      count: 0,
      files: [],
      DocuemntTypes: [],
      addbuttonenabled: true,
      loading: false,
      exportFilesModalVisible: false,
    });
  }

  componentWillUnmount() {
    if (this._toastTimer) clearTimeout(this._toastTimer);
  }

  showToast = (text, color = 'info', duration = 4000) => {
    this.setState({ toastVisible: true, toastText: text, toastColor: color });
    if (this._toastTimer) clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => this.setState({ toastVisible: false }), duration);
  };

  hideToast = () => {
    if (this._toastTimer) clearTimeout(this._toastTimer);
    this.setState({ toastVisible: false });
  };

  validate() {
    const { additional_count } = this.state;
  }

  render() {
    const { additional_count, files, DocuemntTypes, DocumentType, Folders } =
      this.state;

    let additional_search = [];
    let add_button = {};
    let rows = [];
    let file_row = files;
    let hide_button = {};
    let tooltip_text = '';

    if (this.state.collapse) {
      hide_button = '';
      tooltip_text = 'Hide Search';
    } else {
      hide_button = '';
      tooltip_text = 'Show Search';
    }
    let docuemtTypeOptions = [];
    let docuemtTypeOptionValues = [];
    let docuemtTypeNames = [];
    let folderSelect = [];

    for (let i = 0; i < additional_count; i++) {
      if (i + 1 === additional_count) {
        add_button = (
          <Button
            disabled={!this.state.addbuttonenabled}
            className="navbtn s-fonticon-btn"
            outline
            color="success"
            onClick={this.additional}
          >
            
          </Button>
        );
      } else
        add_button = (
          <Button
            id={i}
            className="navbtn s-fonticon-btn"
            outline
            color="danger"
            onClick={this.remove}
          >
            
          </Button>
        );

      if (docuemtTypeOptions.length === 0) {
        if (DocumentType) {
          const type = DocuemntTypes.find(
            (doc) => doc.DocumentType == DocumentType
          );
          if (type) {
            type.Fields.forEach((field) => {
              if (!docuemtTypeOptionValues.includes(field.Name)) {
                docuemtTypeOptionValues.push(field.Name); // create seperate array to check against for duplicate
                docuemtTypeOptions.push(
                  <option value={field.Name}>
                    {field.Description[this.state.locale]}
                  </option>
                );
              }
            });
          }
        } else {
          DocuemntTypes.forEach((types) => {
            types.Fields.forEach((field) => {
              if (!docuemtTypeOptionValues.includes(field.Name)) {
                docuemtTypeOptionValues.push(field.Name); // create seperate array to check against for duplicate
                docuemtTypeOptions.push(
                  <option value={field.Name}>
                    {field.Description[this.state.locale]}
                  </option>
                );
              }
            });
          });
        }
      }

      if (docuemtTypeNames.length === 0) {
        DocuemntTypes.forEach((type) => {
          docuemtTypeNames.push(
            <option value={type.DocumentType}>
              {type.Description[this.state.locale]}
            </option>
          );
        });
      }

      Folders.forEach((folder) => {
        folderSelect.push(<option value={folder}>{folder}</option>);
      });

      if (i + 1 === additional_count) {
      } else {
        additional_search.push(
          <Row id={'filter' + i} form>
            <Col md={1}>
              <ButtonGroup className="add-button-no-header" size="sm">
                {add_button}
              </ButtonGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Input
                  type="select"
                  name={'documentData' + i}
                  onChange={this.handleInputChange}
                  id={'data' + i}
                >
                  <option value="">Select ...</option>
                  {docuemtTypeOptions}
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="select"
                  name={'operator' + i}
                  onChange={this.handleInputChange}
                  id={'operator' + i}
                >
                  <option>Contains</option>
                  <option>Equals</option>
                  <option>Begins With</option>
                  <option>Ends With</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Input
                  type="text"
                  name={'value' + i}
                  onChange={this.handleInputChange}
                  id={'value' + i}
                  placeholder="Search Text"
                />
              </FormGroup>
            </Col>
          </Row>
        );
      }
    }

    return (
      <div className="App">
        <Alert
          color={this.state.toastColor}
          isOpen={this.state.toastVisible}
          toggle={this.hideToast}
          fade
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1080,
            width: 'min(90vw, 480px)',
            textAlign: 'center',
            boxShadow: '0 12px 28px rgba(0,0,0,.2)',
            padding: '14px 18px',
            margin: 0,
          }}
        >
          {this.state.toastText}
        </Alert>
        <Header visible={!this.props.parsed.X3} />
        <div id="s-site-body" className="page-wrapper">
        <div className="s-page">
          <div className="s-page-header">
            <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: "left" }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Document Archive
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Search and browse archived documents
              </Typography>
            </Stack>
          </div>
          <div className="s-content-panel">
          <Flag flag="elastic" entity={{ id: 1 }} case="on">
            <InputGroup
              style={{
                width: '60%',
                alignContent: 'center',
                display: 'inline-flex',
                padding: '20px',
              }}
            >
              <Input
                placeholder="Search ..."
                onChange={(e) => this.setState({ search_text: e.target.value })}
              />
            </InputGroup>
          </Flag>
          <Collapse isOpen={this.state.collapse}>
            <Form onSubmit={this.submit} className="s-button-form">
              <header class="s-h2-head-search">
                <div title="Document" class="s-h2-title" >
                  Search Archive
                </div>
              </header>
              <Row form>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label for="folder" className="s-field-title s-anchored">
                      Folder
                    </Label>
                    <Input
                      type="select"
                      name="Folder"
                      className="s-field-value-edit"
                      value={this.state.Folder}
                      id="Folder"
                      onChange={this.updateFolder}
                    >
                      <option value="">Select ...</option>
                      {folderSelect}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label for="docType" className="s-field-title s-anchored">
                      Document Type
                    </Label>
                    <Input
                      type="select"
                      name="DocumentType"
                      className="s-field-value-edit"
                      value={this.state.DocumentType}
                      id="docType"
                      onChange={this.updateDocType}
                      placeholder="Purchase Order"
                    >
                      <option value="">Select ...</option>
                      {docuemtTypeNames}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label for="docRef" className="s-field-title s-anchored">
                      Document Reference
                    </Label>
                    <Input
                      type="text"
                      name="DocumentRef"
                      id="docRef"
                      className="s-field-value-edit"
                      value={this.state.DocumentRef}
                      onChange={this.updateDocRef}
                      placeholder="..."
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label for="OrderRef" className="s-field-title s-anchored">
                      Order Reference
                    </Label>
                    <Input
                      type="text"
                      name="OrderRef"
                      className="s-field-value-edit"
                      value={this.state.OrderRef}
                      id="OrderRef"
                      onChange={this.updateOrderRef}
                      placeholder="..."
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="BPNUMBER" className="s-field-title s-anchored">
                      BP Number
                    </Label>
                    <Input
                      type="text"
                      name="BPNUMBER"
                      className="s-field-value-edit"
                      value={this.state.BPNUMBER}
                      id="bpNumber"
                      onChange={this.updateBPNumber}
                      placeholder="..."
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label
                      for="Description"
                      className="s-field-title s-anchored"
                    >
                      Description
                    </Label>
                    <Input
                      type="text"
                      name="Description"
                      className="s-field-value-edit"
                      value={this.state.Description}
                      id="description"
                      onChange={this.updateDescription}
                      placeholder="..."
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label for="docRef" className="s-field-title s-anchored">
                      Transaction Number
                    </Label>
                    <Input
                      type="text"
                      name="TransactionNumber"
                      id="transNumber"
                      className="s-field-value-edit"
                      value={this.state.TransactionNumber}
                      onChange={this.updateTransactionNumber}
                      placeholder="..."
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label for="docRef" className="s-field-title s-anchored">
                      Transaction Date
                    </Label>
                    <Input
                      type="text"
                      name="TransactionDate"
                      id="transDate"
                      className="s-field-value-edit"
                      value={this.state.TransactionDate}
                      onChange={this.updateTransactionDate}
                      placeholder="..."
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label for="docRef" className="s-field-title s-anchored">
                      Transaction Value
                    </Label>
                    <Input
                      type="text"
                      name="TransactionValue"
                      id="transValue"
                      className="s-field-value-edit"
                      value={this.state.TransactionValue}
                      onChange={this.updateTransactionValue}
                      placeholder="..."
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label
                      for="dateRageFrom"
                      className="s-field-title s-anchored"
                    >
                      Date From
                    </Label>
                    <Input
                      type="date"
                      name="DateRageFrom"
                      id="dateRageFrom"
                      className="s-field-value-edit"
                      max="9999-12-31"
                      value={this.state.DateRageFrom || ''}
                      onChange={this.handleDateInputChange}
                      placeholder="10/11/2018"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label
                      for="dateRageTo"
                      className="s-field-title s-anchored"
                    >
                      Date To
                    </Label>
                    <Input
                      type="date"
                      name="DateRageTo"
                      id="dateRageTo"
                      className="s-field-value-edit"
                      max="9999-12-31"
                      value={this.state.DateRageTo || ''}
                      onChange={this.handleDateInputChange}
                      placeholder="10/11/2018"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="s-field-core">
                    <Label for="docRef" className="s-field-title s-anchored">
                      User
                    </Label>
                    <Input
                      type="text"
                      name="userName"
                      id="user"
                      className="s-field-value-edit"
                      value={this.state.UserName}
                      onChange={this.updateUserName}
                      placeholder="User Name"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <header class="s-h2-head-search">
                <div title="Document" class="s-h2-title">
                  Custom Tag Fields
                </div>
              </header>
              <Row form>
                <Col md={1}>
                  <ButtonGroup className="add-button" size="sm">
                    {add_button}
                  </ButtonGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Document Type</Label>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Operator</Label>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Value</Label>
                  </FormGroup>
                </Col>
              </Row>
              {additional_search}
              <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'flex-end' }}>
                <MuiButton
                  variant="outlined"
                  color="error"
                  onClick={this.clearstatebtn}
                >
                  Clear
                </MuiButton>
                <Flag flag="v12" entity={{ id: 1 }} case="on">
                  <MuiButton
                    variant="contained"
                    type="submit"
                    disabled={!this.state.addbuttonenabled}
                    startIcon={<SearchIcon />}
                  >
                    Search
                  </MuiButton>
                </Flag>
                <Flag flag="v12" entity={{ id: 1 }} case="off">
                  <MuiButton
                    variant="contained"
                    type="submit"
                    disabled={!this.state.addbuttonenabled}
                    startIcon={<SearchIcon />}
                  >
                    Search
                  </MuiButton>
                </Flag>
              </Box>
            </Form>
          </Collapse>
          <div class="hidecontent">
            <Flag flag="v12" entity={{ id: 1 }} case="on">
              <Button
                outline
                color="primary"
                onClick={this.collapse}
                id="hidebtn"
                className="hidebtn search-button s-fonticon-btn"
              >
                {hide_button}
              </Button>
            </Flag>
            <Flag flag="v12" entity={{ id: 1 }} case="off">
              <Button
                outline
                color="success"
                onClick={this.collapse}
                id="hidebtn"
                className="hidebtn search-button s-fonticon-btn"
              >
                {hide_button}
              </Button>
            </Flag>
          </div>
          <UncontrolledTooltip placement="bottom" target="hidebtn">
            {tooltip_text}
          </UncontrolledTooltip>
          <div class="spacer" />
          <FileTable
            viewPortfolio={true}
            refresh={this.refresh}
            files={this.state.files}
            dropzone={false}
            loading={this.state.loading}
            exportRows={this.exportButtonPressed}
            columnConfig={{ expand: false, actions: true, checkbox: true }}
            onDownloadSelected={this.handleDownloadSelected}
          />
          </div>
        </div>
        </div>
        {this.state.exportFilesModalVisible && (
          <ExportDataRowsModal
            files={this.state.files}
            type={'files'}
            visible={this.state.exportFilesModalVisible}
            toggle={this.exportButtonPressed}
          />
        )}
      </div>
    );
  }
}
export default connect((state) => state)(
  AuthHOC(Search, { name: 'archive_search' })
);
